export const LIQUID_PIXEL_VISUALIZER_FAILED = 'LIQUID_PIXEL_VISUALIZER_FAILED';
export const LIQUID_PIXEL_VISUALIZER_SUCCESSFUL = 'LIQUID_PIXEL_VISUALIZER_SUCCESSFUL';
export const LIQUID_PIXEL_VISUALIZER_ACTIVE_TEXTURE = 'LIQUID_PIXEL_VISUALIZER_ACTIVE_TEXTURE';
export const LIQUID_PIXEL_SET_CHECKING_VALID_TEXTURE = 'LIQUID_PIXEL_SET_CHECKING_VALID_TEXTURE';
